import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: block;
    cursor: pointer;
  }

  #radioWrapper {
    padding-right: var(--com-radio-button-padding, 10px);
    position: relative;
    width: var(--com-radio-size, 20px);
    height: var(--com-radio-size, 20px);
    display: inline-block;
    vertical-align: middle;
  }

  #radioButton {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    left: 0;
    width: var(--com-radio-size, 20px);
    height: var(--com-radio-size, 20px);
    border: var(--com-radio-button-off-size, 2px) solid var(--inactive-grey);
    background-color: transparent;
    border-radius: 50%;
  }

  /* Checked state */
  #radioWrapper.checked #radioButton {
    border: var(--com-radio-button-on-size, calc(var(--com-radio-button-off-size, 2px) * 3)) solid var(--transactional-action);
  }

  /* Disabled state */
  #radioWrapper.disabled #radioButton {
    border-color: var(--inactive-grey);
    background-color: var(--chrome-grey);
  }

  #radioWrapper.checked.disabled #radioButton {
    border-color: var(--inactive-grey);
  }

  /* Error state */
  #radioWrapper.error #radioButton,
  #radioWrapper.checked.error #radioButton {
    border-color: var(--alert-orange);
  }

  /* Hover state */
  @media (hover: hover) {
    #radioWrapper.hover:not(.error):not(.disabled) #radioButton,
    #radioWrapper:hover:not(.error):not(.disabled) #radioButton {
      border-color: var(--transactional-hover);
    }
  }

  /* Focus state */
  :host(:focus) {
    outline: none;
  }

  :host([keyboard-navigation]:focus) #radioWrapper:not(.error) #radioButton {
    border-color: var(--transactional-hover);
  }
</style>
</template>`;

styleElement.register('com-radio-button-style');